/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Coverage_Item1Inputs */

const ja_playdata_about_coverage_item1 = /** @type {(inputs: Playdata_About_Coverage_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国内公式プロリーグおよび大会`)
};

const en_playdata_about_coverage_item1 = /** @type {(inputs: Playdata_About_Coverage_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japanese Domestic official professional leagues and competitions`)
};

/**
* | output |
* | --- |
* | "Japanese Domestic official professional leagues and competitions" |
*
* @param {Playdata_About_Coverage_Item1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_coverage_item1 = /** @type {((inputs?: Playdata_About_Coverage_Item1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Coverage_Item1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_coverage_item1(inputs)
	return en_playdata_about_coverage_item1(inputs)
});